<template>
  <div class="globalHeader">
    <!-- <div class="redBar" v-if="parseInt(get_user.verified_status) == 1 && $route.path != '/view'">
            Your account is verified but restricted, know your account status  <a href="" @click.prevent="redirect()" >{{$t('dash_clickhere')}}</a>                
        </div> -->
    <header class="text-right d-flex align-items-center justify-content-between">
      <div class="d-flex">
        <div class="webTrader-logo mr-4">
          <router-link :to="'/dashboard'" class="green">
            <img
              src="../../../../static/fxView/images/logo-black.svg"
              alt="fxView"
            />
          </router-link>
        </div>
        {{ tabFunc }}
        <div class="d-flex align-items-center justify-content-start mobilehead">
          <div
            class="priceHeader-show d-flex align-items-center justify-content-end whiteBG"
          >
            <div class="iconMobile">
              <feather
                type="menu"
                v-on:click.prevent="$parent.mobmenu = !$parent.mobmenu"
              ></feather>
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <router-link
                to="/wallet"
                class="linkAd d-flex align-items-center"
                @click.native="walletEvent"
              >
                <img
                  height="20"
                  class="iconCell"
                  src="../../../../static/fxView/images/wallertPro.svg"
                  alt="Icon"
                />
                <span class="localI">
                  <span class="sm Tf">{{ $t("head_Wallet") }}</span>
                  <span
                    class="Tf"
                    v-if="parseInt(get_user.verified_status) == 0"
                    >-</span
                  >
                  <span
                    class="Tf"
                    v-else-if="
                      walletblnce.wallet &&
                      walletblnce.wallet.balance &&
                      (parseInt(get_user.verified_status) == 1 || parseInt(get_user.verified_status) == 2)
                    "
                    >{{ toFixedValue(walletblnce.wallet.balance) }}
                    {{ walletblnce.wallet.currency }}</span
                  >
                  <span class="Tf" v-else>0</span>
                </span>
              </router-link>
              <router-link
                :title="
                  walletblnce.loyalty && walletblnce.loyalty.level
                    ? walletblnce.loyalty.level.toLowerCase()
                    : ''
                "
                :to="{ name: 'wallet', params: { Section: 'loyality-point' } }"
                class="linkAd d-flex align-items-center border-0"
                @click.native="loyaltyPointsEvent"
              >
                <!-- <img height="20" class="iconCell" src="../../../../static/fxView/images/lolatyPro.svg" alt="Icon"> -->
                <figure class="imagesArea">
                  <span class="hex">
                    <feather
                      type="star"
                      :class="
                        walletblnce.loyalty && walletblnce.loyalty.level
                          ? walletblnce.loyalty.level.toLowerCase()
                          : ''
                      "
                    ></feather>
                  </span>
                  <!-- <h6 class="HoverTooltip">Bronze</h6> -->
                </figure>
                <span class="localI">
                  <span class="sm Tf">{{ $t("head_loyality") }}</span>
                  <span
                    class="Tf"
                    v-if="
                      walletblnce.loyalty && walletblnce.loyalty.active_points
                    "
                    > {{ (Math.round(walletblnce.loyalty.active_points * 100) / 100).toFixed(2) }}</span
                  >
                  <span class="Tf" v-else>0</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-mainLogo">
        <router-link to="/">
          <img
            src="../../../../static/fxView/images/fxview_logo_white.svg"
            alt="fxView"
        /></router-link>
      </div>
      <div class="d-flex align-items-center rightHeader">
        <div class="toggle-custom-mobile d-xl-none position-relative">
          <button
            class="notifyicon dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            @click.prevent="showdropdown = !showdropdown"
          >
            <feather size="18" type="plus"></feather>
          </button>
          <div class="dropdown-menu lt-0" :class="showdropdown ? 'show' : ''">
            <a
              href="#"
              class="common_btn btn_xs mr-2"
              @click="
                showdropdown = !showdropdown;
                liveDemoFormFunc('1', '/step1');
              "
              >{{ $t("head_createLiveAcc") }}</a
            >
            <a
              href="#"
              class="common_btn btn_xs darkBG"
              @click="
                showdropdown = !showdropdown;
                liveDemoFormFunc('2', '/create-demo-account');
              "
              >{{ $t("head_createDemoAcc") }}</a
            >
          </div>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <a
            href="#"
            class="common_btn btn_xs mr-2 hideXL"
            v-on:click.prevent="liveDemoFormFunc('1', '/step1')"
            >{{ $t("head_createLiveAcc") }}</a
          >
          <a
            href="#"
            class="common_btn btn_xs darkBG hideXL"
            v-on:click.prevent="liveDemoFormFunc('2', '/create-demo-account')"
            >{{ $t("head_createDemoAcc") }}</a
          >
          <!-- <a href="#" class="common_btn btn_xs mr-2 hideXL" v-on:click.prevent="tradeAccount()">
            {{ $t("head_createLiveAcc") }}
          </a>
          <a href="#" class="common_btn btn_xs darkBG hideXL" v-on:click.prevent="tradeAccount()">
            {{ $t("head_createDemoAcc") }}
          </a> -->
          <!----------------notification section---------------------------------->
          <div class="customDropdownOuter">
            <div class="notifyicon">
              <div class="notificationbox dropopen d-flex align-items-center">
                <feather size="18" type="bell"></feather>
                <sup
                  v-if="
                    get_user.unread_notification &&
                    get_user.unread_notification != 0
                  "
                  >{{ get_user.unread_notification }}</sup
                >
              </div>
            </div>
            <div class="customDropdown customDropdown_css">
              <div class="closemenu">
                <feather type="x"></feather>
              </div>
              <div
                class="customDropdownHead p-3 d-flex align-items-center justify-content-between"
              >
                <div class="headTitle">
                  {{ $t("head_Notification") }}
                </div>
                <div
                  class="HeadRight pr-5"
                  v-if="
                    get_user.unread_notification &&
                    get_user.unread_notification != 0
                  "
                >
                  <router-link :to="'/notification'"
                    >{{ $t("head_seeAll") }}
                  </router-link>
                </div>
              </div>
              <div class="customDropdownBox scrollbar" v-if="userNotify != ''">
                <div
                  class="d-flex align-items-center dropdownList"
                  v-for="list in userNotify"
                >
                  <div class="usericon mr-3 text-center">
                    <feather type="mail" size="1rem"></feather>
                  </div>
                  <div
                    v-on:click.prevent="notifyFunc(list)"
                    class="right text-left"
                  >
                    <p>{{ list.message }}</p>
                    <div class="d-block time">
                      {{ list.created_on | moment("DD MMMM YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="noNotifications" v-else>
                <img
                  src="../../../../static/fxView/images/noticket.svg"
                  alt="No Notification"
                />
                {{ $t("head_noNewNotification") }}
              </div>
            </div>
          </div>
          <app-language :page="'left-bar'"> </app-language>
          <!------------------user info section-------------------------------->
          <div class="customDropdownOuter py-0">
            <div
              class="user-header dropopen1 d-flex align-items-center ml-2"
              v-if="get_user.profile.firstname"
            >
              {{ get_user.profile.firstname.charAt(0)
              }}{{ get_user.profile.lastname.charAt(0) }}
            </div>
            <div
              class="user-header dropopen1 d-flex align-items-center ml-2"
              v-else
            >
              {{ get_user.email.charAt(0) }}
            </div>
            <div class="customDropdown dropdownSM userprofilesetting">
              <div
                class="customDropdownHead p-3 d-flex align-items-center text-left"
              >
                <div class="headTitle">
                  <div class="closemenu">
                    <feather type="x"></feather>
                  </div>
                  <div class="name">
                    {{ get_user.profile.firstname }}
                    {{ get_user.profile.lastname }}
                  </div>
                  <p class="mb-0">{{ get_user.email }}</p>
                  <div class="user_verification">
                    <span
                      class="user_verified"
                      v-if="parseInt(get_user.verified_status) == 1"
                      >{{ $t("head_deposit_enabled") }}
                    </span>
                    <span
                      class="user_verified"
                      v-else-if="parseInt(get_user.verified_status) == 2"
                      >{{ $t("head_verified") }}
                    </span>
                    <span class="not_verified" v-else
                      >{{ $t("head_notVerified") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="customDropdownBox">
                <ul class="user" role="menu" aria-labelledby="menu1">
                  <li role="presentation">
                    <router-link :to="'/profile'"
                      >{{ $t("head_profile") }}
                    </router-link>
                  </li>
                  <!-- <li role="presentation"><router-link :to="'/download-platform'">{{$t('downloadPlatform')}} </router-link></li>
                                    <li role="presentation"><router-link :to="'/rest-api'">Developer Console</router-link></li> -->
                  <li role="presentation">
                    <router-link :to="'/change-password'"
                      >{{ $t("head_changePassword") }}
                    </router-link>
                  </li>
                  <li role="presentation">
                    <router-link :to="'/two-fa'"
                      >{{ $t("head_security") }}
                    </router-link>
                  </li>
                  <li role="presentation">
                    <router-link :to="'/refer-a-friend'">{{
                      $t("head_referFriend")
                    }}</router-link>
                  </li>
                  <!--<li role="presentation"><router-link :to="'/subscription-tool'">{{$t('Subscription')}}</router-link></li>-->
                  <div class="border-top"></div>
                  <li>
                    <a
                      role="menuitem"
                      tabindex="-1"
                      href="#"
                      v-on:click.prevent="logout()"
                      >{{ $t("head_logout") }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import * as types from "@/types";
import { mapActions } from "vuex";
import i18n from "@/plugins/lang/i18n";
import language from "./language";

import EventBus from "@/plugins/fxView/provider/candle-history/lib/event-bus";

import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls.ts";
import { path } from "@amcharts/amcharts4/core";

export default {
  name: "Header",
  data() {
    return {
      showText: "1",
      showTab: "",
      langtext: "English",
      flagico: "flag-eng",
      live: "1",
      newUpdate: false,
      shouldShow: false,
      minimize: false,
      new_notification: false,
      showSomethingErrorMessage: false,
      liveDemoIcon: { 0: "Demo", 1: "Live", 0: "Demo", 1: "live" },
      showGenralMessage: false,
      showdropdown: false,
    };
  },
  props: ["show_tab"],
  watch: {
    $route(to, from) {
      this.$parent.mobmenu = false;
    },
  },
  components: {
    appLanguage: language,
  },
  computed: {
    tabFunc() {
      //this.showTab = this.show_tab
      //console.log(this.showTab)
    },
  },
  methods: {
    ...mapActions({
      _runUserLogout: types.RUN_USER_LOGOUT,
      _runSaveuserToken: types.SAVE_FIREBASE_TOKEN,
    }),
    toFixedValue(val) {
      return parseFloat(val).toFixed(2);
    },
    getFirebaseToken() {
      //save user token on the web
    },
    redirectToStep5() {
      //alert("hello atleast called")
      this.$router.replace({ name: "fxView.welcome" });
    },
    changeStatus() {
      this.newUpdate = false;
    },
    notifyFunc(getList) {
      if (getList.notification_type == "TICKET") {
        this.$router.replace({
          name: "fxView.view",
          query: { id: getList.ticket_id },
        });
      }
    },
    logout() {
      const _that = this;
      let input_json = {
        globalParams: {},
        localParams: {
          parameter: _that,
        },
      };
      _that._runUserLogout(input_json);
    },
    getCurrentSteps() {
      let currentStep = this.get_user.step;

      if ("tempStep" in this.get_user && currentStep < this.get_user.tempStep) {
        currentStep = this.get_user.tempStep;
      }

      this.userStep = currentStep;
      return currentStep;
    },
    changeLocale(locale, lang, flagicon) {
      this.langtext = lang;
      this.flagico = "flag " + flagicon;
      i18n.locale = locale;
    },
    // tradeAccount() {
    //   let getData = this.get_user.profile.account[0].demo_live;
    //   console.log(getData, ">>>>>>>>>get_user")
    //   if((this.get_user.profile.account[0].demo_live) == 0) {
    //     this.$router.push('/step1');
    //   }else {
    //     console.log("else")
    //   }
    // },
    liveDemoFormFunc(getData, pathName) {
      if(getData == 0){
        this.$router.replace(pathName);
      } else if (this.get_user.step == 0) {
        this.$router.replace(pathName);
      } else if (getData == 2) {
        this.$router.replace('/create-demo-account');
      } else if (getData == 1) {
        this.$router.replace('/create-live-account');
      }
      location.reload();
      // else if (this.get_user.step >= 1) {
      //   console.log("3")
      //   let lastStep = "/step" + (parseInt(this.get_user.step) + 1);
      //   this.$router.replace(lastStep);
      // }
      // this.$router.replace(pathName);
    },
    demoLiveFunction(getData) {
      this.$emit("localStroageChange", getData);
      localStorage.setItem("demo_live", getData);
      this.$router.replace("/steps1");
    },
    showUpdatedData() {
      //alert("called")
    },
    updateFirstDeposit() {
      const _that = this;
      let input_json = {
        globalParams: {
          transaction_id : this.depositList.records.filter(val => parseInt(val.payment_status) == 1)[0].transaction_id
        },
        localParams: {
          parameter: _that,
        },
      };
      _that._runUpdateFirstDeposit(input_json);
    },
    // callDepositFunc(){
    //   if(parseInt(this.get_user.first_deposit) == 0 && this.checkSuccessDeposit()){
    //     window.gtag('event', 'conversion', {
    //         'send_to': 'AW-10955500403/Z_pQCKjq5OEDEPPW_uco',
    //         'event_callback': window.location
    //     });
    //     window.twq('event', 'tw-och2p-od1n4', {});
    //     this.updateFirstDeposit()
    //   }
    // },
      callDepositFunc(){
        if(parseInt(this.get_user.first_deposit) == 0 && this.checkSuccessDeposit()){
          window.gtag("event", "FTD", { event_name: "FTD"});
          const user_id = this.get_user.profile.user_id
          //window.gtag('event', 'G_FTD', {'event_name': 'G_FTD', 'send_to': 'G-1E20EEPN1W', 'user_id': user_id});
          //window.fbq('trackCustom', 'FTD', { 'value': '200', 'country':  this.get_user.profile.residence_country, 'Currency': 'USD'  }, { 'eventID': this.depositList.records.filter(val => parseInt(val.payment_status) == 1)[0].transaction_id });
          //window.teads_e.push({ conversionType: "Purchase" });
          
          this.updateFirstDeposit()
        }

      },
    listing(){
        let inputJson = {
            'globalParams' : {
                filter: {},
                sort: [],
                search: '',
                page: 1,
                perPage: 15,
            } ,'localParams' : {'parameter' : this,'from' : 'dashboard'}
        }

        this._runGetDepositList(inputJson)
    },
    checkSuccessDeposit(){
      if(this.depositList.totalRecords){
        let data = this.depositList.records.filter(val => parseInt(val.payment_status) == 1)
        if(data.length > 0){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    walletEvent(){
      this.$trackEvent('CP+Dashboard+Wallet+Header');
    },
    loyaltyPointsEvent(){
      this.$trackEvent('CP+Dashboard+Loyalty+Points');
    }
  },
  created() {
    this.listing()
  },
  mounted() {
    const _that = this;
    $(".dropopen").click(function () {
      $(".customDropdown_css").toggleClass("show");
    });

    $(".dropopen1").click(function () {
      $(".userprofilesetting").toggleClass("show");
    });
    $(".tradingaccont").click(function () {
      $(".tradingaccontSM").toggleClass("show");
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".dropopen").length) {
        $(".customDropdown_css").removeClass("show");
      }
      if (!$(event.target).closest(".dropopen1").length) {
        $(".userprofilesetting").removeClass("show");
      }
      if (!$(event.target).closest(".tradingaccont").length) {
        $(".tradingaccontSM").removeClass("show");
      }

      if (
        !$(event.target).closest(".hidetradingModal").length &&
        !$(event.target).closest(".trading1").length &&
        !$(event.target).closest(".trading2").length &&
        !$(event.target).closest(".newtrading").length
      ) {
        _that.showTab = "";
      }

      if (
        !$(event.target).closest(".iconMobile").length &&
        !$(event.target).closest(".iconMobileLeftbar").length
      ) {
        _that.$parent.hide_show = false;
      }
    });
    jQuery(document).ready(function ($) {
      var alterClass = function () {
        var ww = document.body.clientWidth;
        if (ww < 767) {
          _that.showText = "2";
        } else {
          _that.showText = "1";
        }
      };
      $(window).resize(function () {
        alterClass();
      });
      alterClass();
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue